import { SearchApi } from '@ps/api/search';
import {
  OrderEnumItem,
  SearchCommunityChannelSortByEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

import type { CommunityChannel } from '../../types/CommunityChannel';
import { searchItemToChannel } from './searchItemToChannel';

const kDefaultPageSize = 50;

/**
 * One-shot fetch of all channels for the given creator, sorted by
 * `updatedAt` desc — matches the order PopshopRN uses for its
 * channel list (busy channels float to the top).
 *
 * Live updates are layered on top via Firestore `onSnapshot` (see
 * `subscribeToChannels`) — that path doesn't refetch through the
 * search index, it patches the in-memory list.
 */
export async function fetchChannels(
  creatorId: string,
  { pageSize = kDefaultPageSize }: { pageSize?: number } = {},
): Promise<CommunityChannel[]> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannels({
    storeId: creatorId,
    pageNo: 1,
    pageSize,
    sortBy: SearchCommunityChannelSortByEnumItem.UpdatedAt,
    order: OrderEnumItem.Desc,
  });
  return res.data.rows.map(searchItemToChannel);
}
